import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

function generateNext30Days() {
  const out = [];
  const today = new Date();
  for (let i = 1; i <= 30; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    out.push(d);
  }
  return out;
}

export function toISODate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * Centralized booking form state. Loads catalog data on mount and exposes
 * derived values (selected package, computed total, generated dates).
 */
export default function useBookingForm(presetPackage, presetReferral) {
  const [packages, setPackages] = useState([]);
  const [addOns, setAddOns] = useState([]);
  const [slots, setSlots] = useState([]);

  const [step, setStep] = useState(1);
  const [packageId, setPackageId] = useState(presetPackage || "");
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [date, setDate] = useState(null);
  const [timeSlot, setTimeSlot] = useState("");
  const [form, setForm] = useState({
    name: "", email: "", phone: "", address: "", city: "", state: "MD", zip_code: "", notes: "",
  });
  const [payDeposit, setPayDeposit] = useState(true);
  const [referralCode, setReferralCode] = useState((presetReferral || "").toUpperCase());

  useEffect(() => {
    let cancelled = false;
    api.get("/packages").then((r) => {
      if (cancelled) return;
      setPackages(r.data.packages || []);
      setAddOns(r.data.add_ons || []);
      if (presetPackage && (r.data.packages || []).find((p) => p.id === presetPackage)) {
        setPackageId(presetPackage);
      }
    }).catch(() => {});
    api.get("/time-slots").then((r) => {
      if (!cancelled) setSlots(r.data.slots || []);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [presetPackage]);

  const dates = useMemo(() => generateNext30Days(), []);
  const selectedPackage = useMemo(
    () => packages.find((p) => p.id === packageId) || null,
    [packages, packageId]
  );
  const total = useMemo(() => {
    let sum = selectedPackage?.price_from || 0;
    selectedAddOns.forEach((aid) => {
      const a = addOns.find((x) => x.id === aid);
      if (a) sum += a.price;
    });
    return sum;
  }, [selectedPackage, selectedAddOns, addOns]);

  const canNext = () => {
    if (step === 1) return !!packageId;
    if (step === 2) return !!date && !!timeSlot;
    if (step === 3) return form.name && form.email && form.phone && form.address && form.city && form.state;
    return true;
  };

  return {
    // catalog
    packages, addOns, slots, dates,
    // step
    step, setStep,
    // selections
    packageId, setPackageId, selectedAddOns, setSelectedAddOns,
    date, setDate, timeSlot, setTimeSlot,
    form, setForm, payDeposit, setPayDeposit,
    referralCode, setReferralCode,
    // derived
    selectedPackage, total, canNext,
  };
}
